import pgaPolskaImg from './tournament_images/pgaPolska.jpg'
import proGolfQIg from './tournament_images/proQ.jpg'
import fiveStarsImage from './tournament_images/5stars.jpg';
import sokhnaOpenImage from './tournament_images/sokhna_open.png';
import sokhnaClassicImage from './tournament_images/sokhna_classic.png';
import golfMadImage from './tournament_images/golf_mad.jpg'
import allgeriaImage from './tournament_images/allgeria.jpg'
import newGizaImage from './tournament_images/newgiza.jpg'
import haugschlagImage from './tournament_images/haugschlag.jpg'
import homburger from './tournament_images/homburger.png'
import cuberImage from './tournament_images/cuber.png'
import gradiImage from './tournament_images/gradi.jpg'
import kaskada from './tournament_images/kaskada.jpeg'
import euram from './tournament_images/Euram.jpeg'
import vierumaki from './tournament_images/Vierumaki.jpeg'
import pgtq1 from './tournament_images/pgtg1.png';
import wintertour from './tournament_images/wintertour.png'
import sevilla from './tournament_images/Sevilla.png'
import polten from './tournament_images/polten.png'
import cadiz from './tournament_images/cadiz.jpeg'
import kaskada2 from './tournament_images/kaskada2.png'
import interwetten from './tournament_images/Interwetten.jpeg'
import germanchallege from './tournament_images/germanchallenge.png'
import farmfoods from './tournament_images/farmfoods.jpeg'
import sweden from './tournament_images/sweden.png'
import rosact from './tournament_images/rosact.png'
import vierumakihpt from './tournament_images/finnhpt.jpeg'
import gacrosa from './tournament_images/gacrosa.jpg'
import dp from './tournament_images/dp.jpeg'
import floridatour from './tournament_images/WFGT.jpg'
import danish from './tournament_images/danish.jpeg'
import estonia from './tournament_images/estonia.png'
import england from './tournament_images/england.jpeg'

import sbpImage from './sponsor_images/sbp.jpg';
import sbpSmall from './sponsor_images/sbp_small.jpg'
import sobienieImage from './sponsor_images/sobienie.jpg';
import tbv from './sponsor_images/tbv.png'
import ping from './sponsor_images/ping.webp'
import fullmed from './sponsor_images/fullmed.png'
import rosa from './sponsor_images/rosa.png'
import v5 from './sponsor_images/v5.jpg'
import press from './sponsor_images/pressglass.jpg'
import profit from './sponsor_images/Profit_logo.png'
import poolbroker from './sponsor_images/poolbroker.jpg'
import rezonika from './sponsor_images/rezonika.JPG'
import impomed from './sponsor_images/impomed_logo_jpg.jpg'
import pader from './sponsor_images/pader.jpg'
import konopnica from './sponsor_images/konopnica.png'
import medilab from './sponsor_images/medilab.png'
import parfect from './sponsor_images/parfect.png'
import softnet from './sponsor_images/softnet.png'
import kuszewski from './sponsor_images/kuszewski.png'
import tpay from './sponsor_images/tpay.png'
import lubelska from './sponsor_images/lubelska.jpeg'

import magazyn1109 from './media_images/magazyn_sportowy_11_09.png'
import popoludnie1109 from './media_images/popoludnie_11_09.png'
import pzpn from './media_images/kurier_pzpn.png'
import lutytvp3 from './media_images/luty_tvp3.png'
import styczendw from './media_images/styczen_dw.png'
import loza from './media_images/loza.png'
import przeglad from './media_images/przeglad.png'
import pzg from './media_images/pzg.png'
import gnr from './media_images/gnr.jpg'
import kurier from './media_images/kurier.png'
import marzectvp3 from './media_images/marzec_tvp3.png'
import npg from './media_images/NPG.png'

import magazyn1109Small from './media_images/magazyn_sportowy_11_09_small.jpg'
import popoludnie1109Small from './media_images/popoludnie_11_09_small.jpg'
import pzpnSmall from './media_images/kurier_pzpn_small.jpg'
import lutytvp3Small from './media_images/luty_tvp3_small.jpg'
import styczendwSmall from './media_images/styczen_dw_small.jpg'
import lozaSmall from './media_images/loza_small.jpg'
import przegladSmall from './media_images/przeglad_small.jpg'
import pzgSmall from './media_images/pzg_small.jpg'
import gnrSmall from './media_images/gnr_small.jpg'
import kurierSmall from './media_images/kurier_pzpn_small.jpg'
import marzectvp3Small from './media_images/marzec_tvp3_small.jpg'
import popoludnie2025 from './media_images/popoludnie2025.png'
import magazyn2025 from './media_images/magazyn2025.png'


import React, { createContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DataContext = createContext();
export const DataProvider = ({ children }) => {
    const { t } = useTranslation();

    const [pastTournamentsArr] = useState([
        {
            name: "DP World Tour QSchool - First Stage (Golfclub Donnerskirchen)",
            date: "21-24/09/2026",
            place: "T60",
            livescoring: "https://www.europeantour.com/dpworld-tour/frederikshavn-golfklub-2026/leaderboard",
            details: "https://www.europeantour.com/dpworld-tour/frederikshavn-golfklub-2026/",
            image: dp
        },
        {
            name: "HotelPlanner Tour - Rosa Challenge Tour",
            date: "03-06/09/2026",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/rosa-challenge-tour-2026/",
            details: "https://www.europeantour.com/hotelplanner-tour/rosa-challenge-tour-2026/",
            image: rosa
        },
        {
            name: "HotelPlanner Tour - Vierumäki Finnish Challenge supported by Finnish Golf Union",
            date: "20-23/08/2026",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/vierumaki-finnish-challenge-supported-by-finnish-golf-union-2026/",
            details: "https://www.europeantour.com/hotelplanner-tour/vierumäki-finnish-challenge-supported-by-finnish-golf-union-2026/",
            image: vierumaki
        },
        {
            name: "HotelPlanner Tour - Infortar Estonian Challenge",
            date: "30/07-02/08/2026",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/infortar-estonian-challenge-2026/",
            details: "https://www.europeantour.com/hotelplanner-tour/infortar-estonian-challenge-2026/",
            image: estonia
        },
        {
            name: "HotelPlanner Tour - German Challenge powered by VCG",
            date: "09-12/07/2026",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/german-challenge-powered-by-vcg-2026/",
            details: "https://www.europeantour.com/hotelplanner-tour/german-challenge-powered-by-vcg-2026/",
            image: germanchallege
        },
        {
            name: "Pro Golf Tour - Gradi Polish Open by Emeralld 2026",
            date: "01-03/07/2026",
            place: "T34",
            livescoring: "https://www.progolftour.de/tournament-details/gradi-polish-open-2026",
            details: "https://www.progolftour.de/tournament-details/gradi-polish-open-2026",
            image: gradiImage
        },
        {
            name: "HotelPlanner Tour - England Golf Challenge supported by HotelPlanner",
            date: "18-21/06/2026",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/england-golf-challenge-supported-by-hotelplanner-2026/",
            details: "https://www.europeantour.com/hotelplanner-tour/england-golf-challenge-supported-by-hotelplanner-2026/",
            image: england
        },
        {
            name: "HotelPlanner Tour - Interwetten Open",
            date: "11-14/06/2026",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/interwetten-open-2026/",
            details: "https://www.europeantour.com/hotelplanner-tour/interwetten-open-2026/",
            image: interwetten
        },
        {
            name: "HotelPlanner Tour - Danish Golf Challenge",
            date: "21-24/05/2026",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/danish-golf-challenge-2026/",
            details: "https://www.europeantour.com/hotelplanner-tour/danish-golf-challenge-2026/",
            image: danish
        },
        {
            name: "Pro Golf Tour - Haugschlag NÖ Open by perfect eagle 2026",
            date: "28-30/04/2026",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/haugschlag-nö-open-by-perfect-eagle-2026",
            details: "https://www.progolftour.de/tournament-details/haugschlag-nö-open-by-perfect-eagle-2026",
            image: haugschlagImage
        },
        {
            name: "West Florida Golf Tour - Countryside Series",
            date: "02-04/12/2025",
            place: "T14",
            livescoring: "https://www.golfgenius.com/pages/11877294739256555898?fbclid=PAVERFWAQnV6lleHRuA2FlbQIxMABzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAae_e_gqnYYMYOWkVL7AriViiNksH7qJLbChQTfmfWKAaiu-VOb5My0aGCs5tA_aem_4oItS23F_UUorZAfpPyA_g",
            details: "https://www.golfgenius.com/pages/11877294739256555898?fbclid=PAVERFWAQnV6lleHRuA2FlbQIxMABzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAae_e_gqnYYMYOWkVL7AriViiNksH7qJLbChQTfmfWKAaiu-VOb5My0aGCs5tA_aem_4oItS23F_UUorZAfpPyA_g",
            image: floridatour
        },
        {
            name: "Winter Tour - Villa Padierna ",
            date: "02-04/12/2025",
            start: "18",
            livescoring: "https://tournament-site.golfgamebook.com/tournament/67959",
            details: "https://tournament-site.golfgamebook.com/tournament/67959",
            image: wintertour
        },
        {
            name: "Winter Tour - Mijas Golf Los Lagos",
            date: "02-04/12/2025",
            start: "2025-12-02T08:00:00",
            livescoring: "https://www.wintertourmarbella.com/schedule",
            details: "https://www.wintertourmarbella.com/schedule",
            image: wintertour
        },
        {
            name: "Pro Golf Tour - Qualifying School Fleesensee 2025",
            date: "09-10/10/2024",
            place: "T40",
            livescoring: "https://www.progolftour.de/tournament-details/qualifying-school-i-fleesensee-2025",
            details: "https://www.progolftour.de/tournament-details/qualifying-school-i-fleesensee-2025",
            image: pgtq1
        },
        {
            name: "DP World Tour QSchool - First Stage - Golfclub Schloss Ebreichsdorf",
            date: "24-27/09/2025",
            livescoring: "https://www.europeantour.com/dpworld-tour/first-stage-golfclub-schloss-ebreichsdorf-2025/leaderboard",
            details: "https://www.europeantour.com/dpworld-tour/first-stage-golfclub-schloss-ebreichsdorf-2025/leaderboard",
            place: "T45",
            image: dp
        },
        {
            name: "XVI Turniej o Puchar Prezesa Spółdzielczego Banku Powiatowego w Piaskach",
            date: "18-19/09/2025",
            livescoring: "https://eagle.polski.golf/tournament/v336/#/12559/info",
            details: "https://eagle.polski.golf/tournament/v336/#/12559/info",
            place: "Winner",
            image: sbpImage
        },
        {
            name: "WARTA Bartek Marszałek i Przyjaciele",
            date: "15/09/2025",
            place: "Winner",
            livescoring: "https://eagle.polski.golf/tournament/v336/#12482/info",
            details: "https://eagle.polski.golf/tournament/v336/#12482/info",
            image: sobienieImage
        },
        {
            name: "HotelPlanner Tour - GAC Rosa Challenge Tour",
            date: "04-07/09/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/rosa-challenge-tour-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/rosa-challenge-tour-2025/",
            image: gacrosa
        },
        {
            name: "HotelPlanner Tour - Dormy Open",
            date: "28-31/08/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/indoor-golf-group-challenge-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/indoor-golf-group-challenge-2025/",
            image: sweden
        },
        {
            name: "HotelPlanner Tour - Vierumäki Finnish Challenge supported by Finnish Golf Union",
            date: "14-17/08/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/vierumaki-finnish-challenge-supported-by-finnish-golf-union-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/vierumaki-finnish-challenge-supported-by-finnish-golf-union-2025/",
            image: vierumakihpt
        },
        {
            name: "HotelPlanner Tour - Farmfoods Scottish Challenge supported by The R&A",
            date: "31/07-03/08/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/farmfoods-scottish-challenge-supported-by-the-r-a-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/farmfoods-scottish-challenge-supported-by-the-r-a-2025/",
            image: farmfoods
        },
        {
            name: "HotelPlanner Tour - German Challenge powered by VcG",
            date: "17-20/07/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/german-challenge-powered-by-vcg-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/german-challenge-powered-by-vcg-2025/",
            image: germanchallege
        },
        {
            name: "HotelPlanner Tour - Interwetten Open",
            date: "03-06/07/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/european-event-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/european-event-2025/",
            image: interwetten
        },
        {
            name: "HotelPlanner Tour - Raiffeisenbank Golf Challenge",
            date: "12-15/06/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/kaskada-golf-challenge-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/kaskada-golf-challenge-2025/",
            image: kaskada2
        },
        {
            name: "HotelPlanner Tour - Challenge de Cadiz",
            date: "29/05-01/06/2025",
            place: "CUT",
            livescoring: "https://www.europeantour.com/hotelplanner-tour/challenge-de-cadiz-2025/",
            details: "https://www.europeantour.com/hotelplanner-tour/challenge-de-cadiz-2025/",
            image: cadiz
        },
        {
            name: "Pro Golf Tour - Raiffeisen Pro Golf Tour St. Pölten 2025",
            date: "06-09/05/2025",
            scores: "74,78",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/raiffeisen-pro-golf-tour-st-pölten-2025",
            details: "https://www.progolftour.de/tournament-details/raiffeisen-pro-golf-tour-st-pölten-2025",
            image: polten
        },
        {
            name: "Pro Golf Tour - Haugschlag NÖ Open by perfect eagle 2025",
            date: "29/04-01/05/2025",
            scores: "74,77",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/haugschlag-nö-open-by-perfect-eagle-2025",
            details: "https://www.progolftour.de/tournament-details/haugschlag-nö-open-by-perfect-eagle-2025",
            image: haugschlagImage
        },
        {
            name: "Winter Tour - La Cañada Golf Club",
            date: "17-19/02/2025",
            scores: "71, 73, 81",
            place: "T19",
            livescoring: "https://tournament-site.golfgamebook.com/tournament/67959",
            details: "https://www.wintertourmarbella.com/schedule",
            image: wintertour
        },
        {
            name: "Pro Golf Tour - Qualifying School Fleesensee 2024",
            date: "08-09/10/2024",
            scores: "77, 72",
            place: "T39",
            livescoring: "https://www.progolftour.de/tournament-details/qualifying-school-i-fleesensee-2024",
            details: "https://www.progolftour.de/press-detail/q-school-show-increases-excitement-for-2025",
            image: pgtq1
        },
        {
            name: "XV Turniej o Puchar Prezesa Spółdzielczego Banku Powiatowego w Piaskach",
            date: "12-13/09/2024",
            scores: "70, 73",
            place: "Winner",
            livescoring: "https://eagle2.pzgolf.pl/tournament/v320/#/11282/info",
            details: "https://eagle2.pzgolf.pl/tournament/v320/#/11282/info",
            image: sbpImage
        },
        {
            name: "Challenge Tour - Rosa Challenge Tour",
            date: "29/08-01/09/2024",
            scores: "70, 76",
            place: "CUT",
            livescoring: "https://www.europeantour.com/challenge-tour/rosa-challenge-tour-2024/",
            details: "https://www.europeantour.com/challenge-tour/rosa-challenge-tour-2024/",
            image: rosact
        },
        {
            name: "Challenge Tour - Vierumäki Finnish Challenge",
            date: "15-18/08/2024",
            scores: "71, 70",
            place: "CUT",
            livescoring: "https://www.europeantour.com/challenge-tour/vierumaki-finnish-challenge-2024/",
            details: "https://www.europeantour.com/challenge-tour/vierumaki-finnish-challenge-2024/",
            image: vierumaki
        },
        {
            name: "Challenge Tour - Euram Bank Open",
            date: "18-21/07/2024",
            scores: "74, 81",
            place: "CUT",
            livescoring: "https://www.europeantour.com/challenge-tour/euram-bank-open-2024/",
            details: "https://www.europeantour.com/challenge-tour/euram-bank-open-2024/",
            image: euram
        },
        {
            name: "Pro Golf Tour - Gradi Polish Open 2024",
            date: "03-05/07/2024",
            scores: "74, 71",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/gradi-polish-open-2024",
            details: "https://www.progolftour.de/press-detail/gugler-secures-third-win-of-the-season-in-poland",
            image: gradiImage
        },
        {
            name: "Pro Golf Tour - The Cuber Open 2024",
            date: "24-26/06/2024",
            scores: "75, 72",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/the-cuber-open-2024",
            details: "https://www.progolftour.de/press-detail/second-victory-of-the-season-for-meyer-de-beco",
            image: cuberImage
        },
        {
            name: "Challenge Tour - Kaskáda Golf Challenge",
            date: "13-16/06/2024",
            scores: "77, 74",
            place: "CUT",
            livescoring: "https://www.europeantour.com/challenge-tour/kaskada-golf-challenge-2024/leaderboard",
            details: "https://www.europeantour.com/challenge-tour/kaskada-golf-challenge-2024/",
            image: kaskada
        },
        {
            name: "Pro Golf Tour - Royal Homburger Open 2024",
            date: "03-05/06/2024",
            scores: "69, 67",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/royal-homburger-open-2024",
            details: "https://www.progolftour.de/press-detail/foley-finds-recipe-for-success-and-wins-in-bad-homburg",
            image: homburger
        },
        {
            name: "Challenge Tour - Challenge ge España",
            date: "9-12/05/2024",
            scores: "75, 76",
            place: "CUT",
            livescoring: "https://www.europeantour.com/challenge-tour/challenge-de-espana-2024/results?round=4",
            details: "https://www.europeantour.com/challenge-tour/challenge-de-espana-2024/",
            image: sevilla
        },
        {
            name: "Pro Golf Tour - Haugschlag NÖ Open by perfect eagle 2024",
            date: "24-26/04/2024",
            scores: "74, 71",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/haugschlag-nö-open-by-perfect-eagle-2024",
            details: "https://www.progolftour.de/press-detail/jean-bekirian-wins-thriller-at-haugschlag",
            image: haugschlagImage
        },
        {
            name: "Pro Golf Tour - NewGiza Pyramids Challenge 2024",
            date: "17-19/03/2024",
            scores: "78, 75",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/newgiza-pyramids-challenge-2024",
            details: "https://www.progolftour.de/press-detail/verdonk-proves-his-strength-at-the-newgiza-pyramids-challenge",
            image: newGizaImage
        },
        {
            name: "Pro Golf Tour - Allegria Open 2024",
            date: "12-14/03/2024",
            scores: "75, 68, 72",
            place: "T32",
            livescoring: "https://www.progolftour.de/tournament-details/allegria-open-2024",
            details: "https://www.progolftour.de/press-detail/gugler-presents-himself-with-a-premiere-victory-in-egypt",
            image: allgeriaImage
        },
        {
            name: "Pro Golf Tour - Golf Mad Championship 2024",
            date: "24-26/02/2024",
            scores: "81, 76",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/golf-mad-championship-2024",
            details: "https://www.progolftour.de/press-detail/first-tour-victory-play-off-win-for-meyer-de-beco",
            image: golfMadImage
        },
        {
            name: "Pro Golf Tour - Golf Mad Open 2024",
            date: "20-22/02/2024",
            scores: "79, 72",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/golf-mad-open-2024",
            details: "https://www.progolftour.de/tournament-details/golf-mad-open-2024",
            image: golfMadImage
        },
        {
            name: "Pro Golf Tour - Red Sea Egyptian Classic",
            date: "28-30/01/2024",
            scores: "79, 73",
            place: "CUT",
            livescoring: "https://www.progolftour.de/tournament-details/red-sea-egyptian-classic-2024",
            details: "https://www.progolftour.de/press-detail/first-victory-toorop-triumphs-in-the-wind-of-egypt",
            image: sokhnaClassicImage
        },
        {
            name: "Pro Golf Tour - Red Sea Ain Sokhna Open",
            date: "23-25/01/2024",
            livescoring: "https://www.progolftour.de/tournament-details/red-sea-ain-sokhna-open-2024",
            details: "https://www.progolftour.de/press-detail/clerici-celebrates-start-to-finish-victory-at-season-opener",
            scores: "71, 73, 74",
            place: "43",
            image: sokhnaOpenImage
        },
        {
            name: "5 Stars Junior Cup by Adrian Meronk",
            date: "13-15/10/2023",
            livescoring: "https://eagle2.pzgolf.pl/tournament/v315/#/9755/results",
            details: "https://5stars.pl/turniej/5-stars-junior-cup-2023-by-adrian-meronk/13-15-pazdziernika-2023-wroclaw-golf-club/",
            scores: "73, 71, 72",
            place: "2",
            image: fiveStarsImage
        },
        {
            name: "Pro Golf Tour -  Qualifying School I Verden 2023",
            date: "10-11/10/2023",
            livescoring: "https://www.progolftour.de/tournament-details/qschool-i-verden-2023",
            details: "https://www.progolftour.de/press-detail/cards-secured-smiling-faces-at-the-q-school",
            scores: "70, 72",
            place: "T7",
            image: proGolfQIg
        },
        {
            name: "Puchar Prezesa Banku Spółdzielczego Powiatowego w Piaskach",
            date: "23-24/09/2023",
            livescoring: "https://eagle2.pzgolf.pl/tournament/v315/#/9781/results",
            details: "https://golf.wierzchowiska.pl/turnieje.html",
            scores: "74, 69",
            place: "Winner",
            image: sbpImage
        },
        {
            name: "PGA Polska Championship",
            date: "18-19/09/2023",
            livescoring: "https://www.golfbox.dk/livescoring/tour/#/competition/3856001/leaderboard/3639967",
            details: "https://pgapolska.com/pl/aktualnosci/archive/polska/michal-bargenda-zwycieza-w-turnieju-pga-polska-championship",
            scores: "66, 69",
            place: "Winner",
            image: pgaPolskaImg
        },

    ])


    const [upcomingTournamentsArr] = useState([
        {
            name: "Coming soon",
            date: "01/01/2027",
            start: "2027-01-011T08:00:00",
            livescoring: "",
            details: "",
            image: dp
        },
    ])

    const media = [
        {
            name: "Magazyn Sportowy TVP 3 Lublin",
            date: "19/09/2025",
            link: "https://lublin.tvp.pl/89020972/19-wrzesnia-2025",
            image: magazyn2025,
            imageSmall: magazyn2025
        },
        {
            name: "Miłego Popołudnia z TVP 3 Lublin (0:54:00)",
            date: "17/09/2025",
            link: "https://lublin.tvp.pl/88980669/17-wrzesnia-2025",
            image: popoludnie2025,
            imageSmall: popoludnie2025
        },
        {
            name: "Niepoważny Podcast Golfowy - odc. 9",
            date: "11/09/2024",
            link: "https://open.spotify.com/episode/2qADYM8vmfNqTP4GLwKoBB?si=5fcb4d30f74c44df",
            image: npg,
            imageSmall: npg
        },
        {
            name: "Magazyn Sportowy TVP 3 Lublin",
            date: "11/09/2024",
            link: "https://lublin.tvp.pl/82251349/11-wrzesnia-2024",
            image: magazyn1109,
            imageSmall: magazyn1109Small
        },
        {
            name: "Miłego Popołudnia z TVP 3 Lublin (1:37:07)",
            date: "11/09/2024",
            link: "https://lublin.tvp.pl/82249115/11-sierpnia-2024",
            image: popoludnie1109,
            imageSmall: popoludnie1109Small
        },
        {
            name: "Kurier Lubelski",
            date: "10/06/2024",
            link: "https://kurierlubelski.pl/zawodowy-golfista-z-lublina-michal-bargenda-gral-z-lewandowskim-i-innymi-reprezentantami-polski/ar/c2-18595807",
            image: pzpn,
            imageSmall: pzpnSmall
        },
        {
            name: "Poranek z TVP 3 Lublin - Golf bez tajemnic",
            date: "07/03/2024",
            link: "https://lublin.tvp.pl/76319748/golf-bez-tajemnic?fbclid=IwAR3YuPe0vVl3GZ9ScFsm0PESnRnyWcNZGjvZ6bDRdJH9qJ4WWoc8sdPrJIA_aem_AUKNZDr6-j3ettx46N0Cp7dcJvvCkaP0j0nkUtpybSPav9hnW-ph2pbS9EfbXt3PLVl9kC4KNGlmKMmsdvAmfwsz",
            image: marzectvp3,
            imageSmall: marzectvp3Small
        },
        {
            name: "Kurier Lubelski",
            date: "26/02/2024",
            link: "https://kurierlubelski.pl/rozmowa-z-michalem-bargenda-pierwszym-zawodowym-golfista-z-lublina-presja-coraz-wieksza/ar/c2-18338957?utm_source=facebook.com&utm_medium=1-liga&utm_content=sport&utm_campaign=rozmowa-z-michalem-bargenda-pierwszym-zawodowym-golfista-z-lublina-presja-coraz-wieksza&fbclid=IwAR1Lde08Bj9ayzamjwoarfNFu3SJpgEYGetrEhuWlf92aLj28oRJMFHwJ30",
            image: kurier,
            imageSmall: kurierSmall
        },
        {
            name: "Poranek z TVP 3 Lublin",
            date: "02/02/2024",
            link: "https://drive.google.com/file/d/1oAtFDErEAPa2DBz90gsRkS6uIENy0spO/view?usp=share_link",
            image: lutytvp3,
            imageSmall: lutytvp3Small
        },
        {
            name: "Dziennik Wschodni",
            date: "19/01/2024",
            link: "https://www.dziennikwschodni.pl/lublin/zawodowiec-z-lublina-rozpoczyna-przygode-z-pro-golf-tour,n,1000336732.html?fbclid=IwAR3lMaA4sHX9AbwPQVXPGgoebWNTDH-AeR2FLB-Sd8R-sXfwClhJMrS_fCU",
            image: styczendw,
            imageSmall: styczendwSmall
        },
        {
            name: "Golf&Roll - Loża szyderców",
            date: "12/2023",
            link: "https://drive.google.com/file/d/1kil1uqjYpG7bbQJTSeVBAXoGx4TjDBME/view?usp=share_link",
            image: loza,
            imageSmall: lozaSmall
        },
        {
            name: "Onet - Przegląd Sportowy",
            date: "30/10/2023",
            link: "https://przegladsportowy.onet.pl/golf/przyjechala-z-usa-w-kadrze-zostali-para-celem-sa-igrzyska/9mhrvcz",
            image: przeglad,
            imageSmall: przegladSmall
        },
        {
            name: "Polski Związek Golfa",
            date: "21/10/2023",
            link: "https://polski.golf/2023/10/bargenda-dolacza-do-grona-polskich-profesjonalistow/",
            image: pzg,
            imageSmall: pzgSmall
        },
        {
            name: "Golf&Roll",
            date: "07/2023",
            link: "https://drive.google.com/file/d/1Ca9HPfLQe5vgoFuzKcQjzXugTEVeQxJe/view?usp=share_link",
            image: gnr,
            imageSmall: gnrSmall
        },
    ]
    const [sponsorsArr] = useState([
        {
            image: sbpImage,
            smallImage: sbpSmall,
            name: "Spółdzielczy Bank Powiatowy w Piaskach",
            link: "https://www.sbppiaski.pl",
            type: t("Primary Partner")
        },
        {
            image: ping,
            name: "PING Europe",
            link: "https://www.pingeurope.com/?gad_source=1&gclid=Cj0KCQjwqpSwBhClARIsADlZ_TlMeRP8ZdI_-u8mczKoqSQaI4-zBauUSIs9vuaXbJIwqRuI9lsh-gcaAksTEALw_wcB",
            type: "Partner"
        },
        {
            image: sobienieImage,
            name: "Sobienie Królewskie Golf & Country Club",
            link: "https://www.sobieniekrolewskie.pl",
            type: "Partner"
        },
        {
            image: poolbroker,
            name: "Pool Broker",
            link: "https://www.poolbroker.pl",
            type: "Partner"
        },/* 
        {
            image: tbv,
            name: "TBV",
            link: "https://tbv.pl",
            type: "Partner"
        }, */
        {
            image: fullmed,
            name: "Full-Med",
            link: "https://full-med.pl",
            type: "Partner"
        },

        {
            image: rezonika,
            name: "Rezonika",
            link: "https://rezonika.pl",
            type: "Partner"
        },
        {
            image: impomed,
            name: "IMC IMPOMED CENTRUM",
            link: "https://www.impomed.pl",
            type: "Partner"
        },
        /* {
            image: pader,
            name: "Międzynarodowe Liceum Ogólnokształcące Paderewski w Lublinie",
            link: "https://paderewski.lublin.pl/liceum/pl/strona-glowna/",
            type: "Partner"
        }, */

        {
            image: konopnica,
            name: "Gmina Konopnica",
            link: "https://konopnica.eu",
            type: "Partner"
        },

        {
            image: medilab,
            name: "Medilab",
            link: "https://www.medilab.pl",
            type: "Partner"
        },
        {
            image: kuszewski,
            name: "Fundacja Rodziny Kuszewskich",
            link: "https://fundacjarodzinykuszewskich.pl",
            type: "Partner"
        },
        {
            image: tpay,
            name: "Tpay",
            link: "https://tpay.com",
            type: "Partner"
        },
        {
            image: softnet,
            name: "SOFTNET",
            link: "https://www.softnet.pl",
            type: "Partner"
        },
        {
            image: lubelska,
            name: "Lubelska Fundacja Rozwoju Golfa",
            link: "https://lubelskafundacjarozwojugolfa.org",
            type: "Partner"
        },
        {
            image: profit,
            name: "Profit",
            link: "",
            type: "Partner"
        }

    ])
    const [partnersArr] = useState([
        {
            image: ping,
            name: "PING Europe",
            link: "https://www.pingeurope.com/?gad_source=1&gclid=Cj0KCQjwqpSwBhClARIsADlZ_TlMeRP8ZdI_-u8mczKoqSQaI4-zBauUSIs9vuaXbJIwqRuI9lsh-gcaAksTEALw_wcB"
        },
        {
            image: sobienieImage,
            name: "Sobienie Królewskie Golf & Country Club",
            link: "https://www.sobieniekrolewskie.pl"
        },
        {
            image: poolbroker,
            name: "Pool Broker",
            link: "https://www.poolbroker.pl"
        },/* 
        {
            image: tbv,
            name: "TBV",
            link: "https://tbv.pl"
        }, */

        {
            image: fullmed,
            name: "Full-Med",
            link: "https://full-med.pl",
        },

        {
            image: rezonika,
            name: "Rezonika",
            link: "https://rezonika.pl"
        },
        {
            image: impomed,
            name: "IMC IMPOMED CENTRUM",
            link: "https://www.impomed.pl"
        },
        /*  {
             image: pader,
             name: "Międzynarodowe Liceum Ogólnokształcące Paderewski w Lublinie",
             link: "https://paderewski.lublin.pl/liceum/pl/strona-glowna/"
         }, */
        {
            image: konopnica,
            name: "Gmina Konopnica",
            link: "https://konopnica.eu",
            type: "Partner"
        },
        {
            image: medilab,
            name: "Medilab",
            link: "https://www.medilab.pl",
            type: "Partner"
        },
        {
            image: kuszewski,
            name: "Fundacja Rodziny Kuszewskich",
            link: "https://fundacjarodzinykuszewskich.pl",
            type: "Partner"
        },
        {
            image: tpay,
            name: "Tpay",
            link: "https://tpay.com",
            type: "Partner"
        },
        {
            image: softnet,
            name: "SOFTNET",
            link: "https://www.softnet.pl",
            type: "Partner"
        },
        {
            image: lubelska,
            name: "Lubelska Fundacja Rozwoju Golfa",
            link: "https://lubelskafundacjarozwojugolfa.org",
            type: "Partner"
        },
        {
            image: profit,
            name: "Profit",
            link: "",
            type: "Partner"
        }

    ])
    const [partnersChallengeArr] = useState([
        {
            image: rosa,
            name: "Rosa Golf Club",
            link: "https://rosa.golf"
        },
        {
            image: press,
            name: "Press Glass",
            link: "https://www.pressglass.com/"
        },
        {
            image: v5,
            name: "V5 Group",
            link: "https://www.v5group.pl/"
        }

    ])
    const [mainPartner] = useState({
        image: sbpImage,
        smallImage: sbpSmall,
        name: "Spółdzielczy Bank Powiatowy w Piaskach",
        link: "https://www.sbppiaski.pl"
    })

    const [parfectPartner] = useState({
        image: parfect,
        smallImage: parfect,
        name: "PARfect Performance",
        link: "https://parfectperformance.com"
    })
    return (
        <DataContext.Provider value={{ pastTournamentsArr, upcomingTournamentsArr, sponsorsArr, media, partnersArr, mainPartner, parfectPartner, partnersChallengeArr }}>
            {children}
        </DataContext.Provider>
    );
}
export default DataProvider;